// OnlineDot — indicador de status online/offline
import { h } from 'preact';
import { T } from '../../styles/tokens';

interface OnlineDotProps {
  online: boolean;
  size?: number;
  style?: any;
}

export function OnlineDot({ online, size = 8, style }: OnlineDotProps) {
  return (
    <span style={{
      display: 'inline-block', width: size, height: size,
      borderRadius: '50%',
      background: online ? T.success : T.textDisabled,
      flexShrink: 0,
      ...style,
    }} />
  );
}
